import { fetchWrapper } from '../helpers';

export const ratingService = {
  postLinkage,
  getCatalog,
  getDataInit,
  getDataTop,
  getDataURL,
  getRouterPaths
};

const baseUrlAPI = `${process.env.API_BASE_URL}`;

const queryString = (params) => Object.keys(params).map(key => key + '=' + params[key]).join('&');

const arrQName = [
  "project_size",
  "industry",
  "location",
  "hourly_rate",
  "company_size"
]

// API
function postLinkage(params) {
  const url = `/linkage`;
  return fetchWrapper.post(`${baseUrlAPI}${url}`, params);
}

function getRouterPaths() {
  const url = `/router-paths`;
  return fetchWrapper.get(`${baseUrlAPI}${url}`);
}

//--
function getCatalog(linkage) {
  const { parent_value, focus, value, item } = linkage;
  const q = { ...(item && item.params) };
  const url = `/rating/catalog?category_code=${parent_value}&focus_name=${focus}&focus_code=${value}&${queryString(q)}`;

  return fetchWrapper.get(`${baseUrlAPI}${url}`);
}

//--
function getDataURL(linkage, query, params) {
  const { parent_value, focus, value, item } = linkage;
  const q = { ...query };

  ///q.project_size = query.project_size || (params ? params.project_size : 'PS1')
  q.page = query.page || (params ? params.page : 1);

  if (item && params && params.industry) {
    q.industry = params.industry;
  }

  if (item && params && params.location) {
    q.location = params.location;
  }

  const queryString = Object.keys(q).filter((f) => f !== 'slug').map((key) => key + '=' + q[key]).join('&');
  // const url = `/companies/all/${parent_value}?${focus}=${value}&${queryString}`;
  const url = `/companies/${parent_value}?${focus}=${value}&${queryString}`;

  return `${baseUrlAPI}${url}`;
}

// --
function getDataInit(linkage, query, params) {
  const url = getDataURL(linkage, query, params);
  return fetchWrapper.get(url);
}

//--
function getDataTop(linkage, query, params) {
  const { parent_value } = linkage;
  const q = { ...query };
  delete q.slug;

  const finalQueryString = queryString(q);
  const url = `/companies/top/${parent_value}?${finalQueryString}`;

  return fetchWrapper.get(`${baseUrlAPI}${url}`);
}